import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
// import { baseUrl, config, requestID } from "../../../common/utils";

export const getMyOrders = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getMyOrderWithItems",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}




export const getOrderTransaction = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getOrderTransaction",
            data,
            config
        );
        console.log({ response })
        return response.data
    } catch (error: any) {
        return error
    }
}






export const auditTransaction = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/auditTransaction",
            data,
            config
        );
        console.log({ response })
        return response.data
    } catch (error: any) {
        return error
    }

}


export const verifyTransaction = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/verifyTransaction",
            data,
            config
        );
        console.log({ response })
        return response.data
    } catch (error: any) {
        return error
    }
}


export const getCashierOrders = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getCashiersOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

//  product_id: selectedProduct,
//         startDate,
//         endDate,



export const getCustomerOrderDetails = async (selectedProduct) => {
    const data = {
        requestID: requestID(),...selectedProduct
        // startDate:startDate,
        // endDate:endDate,
        // stockId:selectedProduct.product_id,
       // page:rows   
    };
    console.log({data})
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/stockSalesReport_single",
            data,
            config
        );
        console.log(response) 
        return response.data.data
    } catch (error: any) {
        return error
    }
}

export const getCustomerStatusReport = async (selectedProduct) => {
    const data = {
        requestID: requestID(),...selectedProduct
        // startDate:startDate,
        // endDate:endDate,
        // stockId:selectedProduct.product_id,
       // page:rows   
    };
    console.log({data})
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/stockSalesReport",
            data,
            config
        );
        console.log({ response })
        return response.data
    } catch (error: any) {
        return error
    }
}

export const getStockSaleDetails = async (selectedProduct) => {
    const data = {
        requestID: requestID(),...selectedProduct
        // startDate:startDate,
        // endDate:endDate,
        // stockId:selectedProduct.product_id,
       // page:rows   
    };
    console.log({data})
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/stockSalesReport_single",
            data,
            config
        );
        console.log(response) 
        return response.data.data
    } catch (error: any) {
        return error
    }
}

export const getStockSalesReport = async (selectedProduct) => {
    const data = {
        requestID: requestID(),...selectedProduct
        // startDate:startDate,
        // endDate:endDate,
        // stockId:selectedProduct.product_id,
       // page:rows   
    };
    console.log({data})
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/stockSalesReport",
            data,
            config
        );
        console.log({ response })
        return response.data
    } catch (error: any) {
        return error
    }
}


 


export const fetchSalesData_withdate_staffId_receptionist = async (rows,start,end,staffId,payment_method) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows,
        mode_of_payment:payment_method

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_receptionist",
            data,
            config
        );
        console.log({ 'hello' : response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const fetchSalesData_withdate_staffId_paymentMethodCall = async (rows,start,end,staffId,payment_method) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows,
        mode_of_payment:payment_method

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_paymentmethod",
            data,
            config
        );
        console.log({ 'hello' : response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const fetchOrderDetails_items = async (order_id,start_date,end_date,branch_id) => {
    const data = {
        requestID: requestID(),
        order_id:order_id,
        start_date:start_date,
        end_date:end_date,
        branch_id:branch_id

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/fetchOrderDetails_items",
            data,
            config
        );
        console.log({ 'hello' : response.data })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const fetchSalesData_withdate_staffId_paymentMethodCall_crypto = async (rows,start,end,staffId,payment_method) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows,
        mode_of_payment:payment_method

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_paymentmethod_crypto",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const fetchSalesData_withdate_staffId_paymentMethodCall_usd = async (rows,start,end,staffId,payment_method) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows,
        mode_of_payment:payment_method

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_paymentmethod_usd",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getManagersOrders_reciept_withdate_none_usd = async (rows,start,end,staffId) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_none_usd",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getManagersOrders_reciept_withdate = async (rows,start,end,staffId) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getManagersOrders_reciept_withdate_giftcard = async (rows,start,end,staffId) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows

    };
    try {
        ///real
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_giftcard",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getManagersOrders_reciept_withdate_usd = async (rows,start,end,staffId) => {
    const data = {
        requestID: requestID(),
        start:start,
        end:end,
        staffId:staffId,
        page:rows

    };
    try {
        ///real
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_usd",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}






export const getManagersOrders_allbranch_reciept_usd = async (rows) => {
    const data = {
        requestID: requestID(),
        page: rows
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_usd",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }
}





export const getManagersOrders_reciept_usd_giftcard = async (rows) => {
    const data = {
        requestID: requestID(),
          
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_usd_giftcard",
            data,
            config
        );
        console.log({ response })
     //   return;
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getManagersOrders_reciept_usd = async (rows) => {
    const data = {
        requestID: requestID(),
          
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_usd",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getManagersOrders_reciept_none_crypto = async (rows) => {
    const data = {
        requestID: requestID(),          
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_none_crypto",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getManagersOrders_reciept_none_usd = async (rows) => {
    const data = {
        requestID: requestID(),          
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept_none_usd",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
// Update single order item
export const updateOrderItem = async (itemId: number, data: {
  quantity: number;
  price: number;
  status: string;
}) => {
  try {
    const response = await axios.put(baseUrl() + "reports/updateOrderItem", data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update order summary
export const updateOrderSummary = async (orderId: string, data: {
  mode_of_payment: string;
  amount_paid: string;
  balance_due: string;
  order_status: string;
  payment_status: string;
  transaction_category?: string;
}) => {
  try {
    const response = await axios.put(baseUrl() + "reports/updateOrderSummary", data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getManagersOrders_reciept = async (rows) => {
    const data = {
        requestID: requestID(),
          
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch_reciept",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getManagersOrders = async (rows) => {
    const data = {
        requestID: requestID(),
        page:rows

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getManagersOrders_allbranch",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getMerchantOrders = async (payload) => {
    const data = {
        requestID: requestID(),...payload

    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getMerchantOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getBranchesList = async (id) => {
    const data = {
        requestID: requestID(),
        business_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "businesss/getBranchList2",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const approvedOrders = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/approvedOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}